/** Converted sample of the legacy KPI S3 payload → recursive canvas + datasets. */

export const kpiCanvas = {
  schema_version: 1,
  page_id: 'tenantabc/cm-office-kpi',
  tenant_id: 'tenantabc',
  title: 'CM and Office Team Monthly KPI Dashboard',
  subtitle: 'August 2026 vs September 2026',
  visibility: { policy: 'private' },
  theme: { mode: 'light', primary: '#1B4F72' },
  dataset_slots: [
    { id: 'kpi_summary', dataset_id: 'ds_kpi_summary', required: true, on_missing: 'block_publish' },
    { id: 'craftsman_kpi', dataset_id: 'ds_craftsman', required: true, on_missing: 'block_publish' },
    { id: 'actions', dataset_id: 'ds_actions', required: false, on_missing: 'fallback' },
  ],
  root: {
    id: 'root',
    component: 'builtin:Stack',
    version: '1.0.0',
    props: { spacing: 3, direction: 'column' },
    children: [
      {
        id: 'title',
        component: 'builtin:Typography',
        version: '1.0.0',
        props: { variant: 'h4', text: '{{page.title}}' },
      },
      {
        id: 'subtitle',
        component: 'builtin:Typography',
        version: '1.0.0',
        props: { variant: 'subtitle1', text: '{{page.subtitle}}' },
      },
      {
        id: 'banner',
        component: 'builtin:Banner',
        version: '1.0.0',
        bindings: { text: { dataset: 'kpi_summary', path: 'banner_text' } },
        props: {},
      },
      {
        id: 'metrics',
        component: 'builtin:Grid',
        version: '1.0.0',
        props: { columns: { xs: 1, sm: 2, md: 3 }, spacing: 2 },
        children: [
          {
            id: 'm-opp',
            component: 'builtin:MetricCard',
            version: '1.0.0',
            props: { label: 'Opportunity' },
            bindings: {
              value: { dataset: 'kpi_summary', path: 'metrics.opportunity.value' },
              caption: { dataset: 'kpi_summary', path: 'metrics.opportunity.caption' },
            },
          },
          {
            id: 'm-completed',
            component: 'builtin:MetricCard',
            version: '1.0.0',
            props: { label: 'Completed Jobs', accent: true },
            bindings: {
              value: { dataset: 'kpi_summary', path: 'metrics.completed.value' },
              caption: { dataset: 'kpi_summary', path: 'metrics.completed.caption' },
            },
          },
          {
            id: 'm-cancels',
            component: 'builtin:MetricCard',
            version: '1.0.0',
            props: { label: 'Cancels after Dispatch' },
            bindings: {
              value: { dataset: 'kpi_summary', path: 'metrics.cancels.value' },
              caption: { dataset: 'kpi_summary', path: 'metrics.cancels.caption' },
            },
          },
        ],
      },
      {
        id: 'table',
        component: 'builtin:DataTable',
        version: '1.0.0',
        props: {
          title: 'Craftsman Team KPI Comparison',
          columns: [
            { key: 'kpi', label: 'KPI' },
            { key: 'month1', label: 'August 2026' },
            { key: 'month2', label: 'September 2026' },
            { key: 'change', label: 'Change' },
            { key: 'status', label: 'Status' },
          ],
        },
        bindings: { rows: { dataset: 'craftsman_kpi', path: 'rows' } },
      },
      {
        id: 'actions-list',
        component: 'builtin:List',
        version: '1.0.0',
        props: { title: 'Management Action Items' },
        bindings: { items: { dataset: 'actions', path: 'items' } },
      },
      {
        id: 'timeline',
        component: 'external:mock/StatusTimeline',
        version: '1.0.0',
        props: {},
        fallback: {
          id: 'timeline-fallback',
          component: 'builtin:Banner',
          version: '1.0.0',
          props: { text: 'Status timeline unavailable (sandbox runtime not implemented).' },
        },
      },
    ],
  },
};

export const kpiManifest = {
  manifest_id: 'man_kpi_1',
  page_id: 'tenantabc/cm-office-kpi',
  tenant_id: 'tenantabc',
  canvas_version: 1,
  mode: 'latest_validated',
  entries: [
    { slot: 'kpi_summary', dataset_id: 'ds_kpi_summary', dataset_version: 1, status: 'validated' },
    { slot: 'craftsman_kpi', dataset_id: 'ds_craftsman', dataset_version: 1, status: 'validated' },
    { slot: 'actions', dataset_id: 'ds_actions', dataset_version: 1, status: 'validated' },
  ],
};

export const kpiDatasets = {
  ds_kpi_summary: {
    status: 'validated',
    data: {
      banner_text:
        'Reporting months: August 2026 vs September 2026. Improved: Cancels after Dispatch. Declines: Opportunity, Completed Jobs.',
      metrics: {
        opportunity: { value: '50', caption: 'Decline' },
        completed: { value: '43', caption: 'Decline' },
        cancels: { value: '7', caption: 'Improved' },
      },
    },
  },
  ds_craftsman: {
    status: 'validated',
    data: {
      rows: [
        { kpi: 'Opportunity', month1: '56', month2: '50', change: '-6', status: 'Decline' },
        {
          kpi: 'Cancels after Dispatch',
          month1: '10',
          month2: '7',
          change: '-3',
          status: 'Improved',
        },
        { kpi: 'Completed Jobs', month1: '55', month2: '43', change: '-12', status: 'Decline' },
      ],
    },
  },
  ds_actions: {
    status: 'validated',
    data: {
      items: [
        { title: 'Opportunity', subtitle: 'Declined vs prior month', value: 'Review' },
        { title: 'Completed Jobs', subtitle: 'Declined vs prior month', value: 'Review' },
      ],
    },
  },
};

/** Second refresh snapshot — canvas version unchanged, data updated. */
export const kpiDatasetsRefresh2 = {
  ds_kpi_summary: {
    status: 'validated',
    data: {
      banner_text: 'Refreshed snapshot #2',
      metrics: {
        opportunity: { value: '61', caption: 'Improved' },
        completed: { value: '48', caption: 'Improved' },
        cancels: { value: '5', caption: 'Improved' },
      },
    },
  },
  ds_craftsman: {
    status: 'validated',
    data: {
      rows: [
        { kpi: 'Opportunity', month1: '56', month2: '61', change: '+5', status: 'Improved' },
        {
          kpi: 'Cancels after Dispatch',
          month1: '10',
          month2: '5',
          change: '-5',
          status: 'Improved',
        },
        { kpi: 'Completed Jobs', month1: '55', month2: '48', change: '-7', status: 'Decline' },
      ],
    },
  },
  ds_actions: {
    status: 'validated',
    data: { items: [{ title: 'Completed Jobs', subtitle: 'Still down', value: 'Review' }] },
  },
};
